import { debug, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { numberToEuroAmount } from "types/amount";
import { getErrorWithCode } from "types/error";
import { ISigningResponse } from "types/signing";
import { AccountShort } from "../common/Account";
import { SigningComponent } from "../signing/views/SigningComponent";
import { FormattedAmount } from "../util/FormattedAmount";
import { QuickDrawdownStore } from "./QuickDrawdownStore";

type IProps = RouteComponentProps<{}> & {
    store: QuickDrawdownStore;
};

@observer
export class QuickDrawdownSigning extends React.Component<IProps, {}> {
    render() {
        const cardName = this.props.store.cardStore && this.props.store.cardStore.card ? this.props.store.cardStore.card.productI18N : "-";

        return (
            <SigningComponent
                signingInfo={this.props.store.transferResponse ? this.props.store.transferResponse.signInfo : undefined}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelSet>
                                <pr.SigningLabelTitle>{ui.__("common.recipient")}</pr.SigningLabelTitle>
                                <AccountShort account={this.props.store.accountsStore.selectedAccount} />
                            </pr.SigningLabelSet>
                            <br />

                            <pr.SigningLabelSet>
                                <pr.SigningLabelTitle>{ui.__("common.amount")}</pr.SigningLabelTitle>
                                <FormattedAmount amount={numberToEuroAmount(this.props.store.amount)} big />
                            </pr.SigningLabelSet>
                        </pr.SigningLabelContainer>
                    </div>

                }

                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute("success");
                }}

                onError={(error: any) => {
                    const badRequest = getErrorWithCode(error, "BAD_REQUEST");
                    if (badRequest && badRequest.message) {
                        this.props.store.badRequestMessage = badRequest.message;
                        pushRoute("/quick-drawdown/error");
                    }
                }}

                onRetry={async () => await this.props.store.transfer()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/quickDrawdown/QuickDrawdownSigning.tsx